import React, { Component } from 'react';
import LayoutBackoffice from '../../header_footer/LayoutBackoffice';


import FormAviso from './FormAviso';

class CreateAviso extends Component {
    constructor(props) {
        super(props);
        this.state = {
            aviso: {}
          };
    }

    render() {
        return (
            <LayoutBackoffice>
                <div className="container">
                    <h2 className="backoffice-titulo-pagina">Adicionar aviso</h2>
                    <FormAviso mode="create"></FormAviso>
                </div>
            </LayoutBackoffice>
        );
    }
}

export default CreateAviso;